export const enCommon = {
  close: 'Close',
  account: 'Account',
  back: 'Go back',
  openMenu: 'Open menu',
  closeMenu: 'Close menu',
  explore: 'Explore',
  explorer: 'Explorer',
  token: 'Token',
  network: 'Network',
  symbol: 'Symbol',
  decimals: 'Decimals',
  fee: 'Fee',
  feeTier: 'Fee tier',
  protocol: 'Protocol',
  all: 'All',
  results: 'Results',
  today: 'Today',
  yesterday: 'Yesterday',
  noDate: 'No date',
  transaction: 'Transaction',
  confirmed: 'Confirmed',
  pending: 'Pending',
  confirmedPlural: 'Confirmed',
  pendingPlural: 'Pending',
  assetCount: (count: number) => `${count} asset${count === 1 ? '' : 's'}`,
  goToExplore: 'Go to Explore',
  viewProfile: 'View profile',
  copyAddressCopied: (label: string) => `${label} copied`,
  marketDataEmpty: 'No market data available.',
  website: 'Website',
  whitepaper: 'Whitepaper',
  links: 'Links',
  aboutProject: 'About the project',
  info: 'Info',
  chart: 'Chart',
  price: 'Price',
  invert: 'Invert',
  invertQuote: 'Invert quote',
  invertPair: 'Invert pair',
  loadingQuote: 'Loading quote…',
  loading: 'Loading…',
  loadingPool: 'Loading pool…',
  noOnChainPool: 'No on-chain pool for this pair',
  noPool: 'No pool',
  canonicalSource: 'Canonical source:',
  documents: 'Documents',
  reading: 'Reading',
  downloadTxt: 'Download .txt',
  downloadTxtAria: 'Download document as .txt',
  documentUnavailableLocale: 'Document not available in this language.',
  trade: 'Trade',
  addLiquidity: 'Add liquidity',
  removeLiquidity: 'Remove liquidity',
  token0: 'Token 0',
  token1: 'Token 1',
  token2: 'Token 2',
  tokenA: 'Token A',
  tokenB: 'Token B',
  selectToken: 'Select token',
  selectTokenA: 'Select token A',
  selectTokenB: 'Select token B',
  selectToken1: 'Select token 1',
  selectToken2: 'Select token 2',
  poolV2: 'Pool V2',
  spotPrice: 'Spot price',
  apy: 'APY',
  onChainData: 'On-chain data',
  contract: 'Contract',
  wethContract: 'WETH contract',
  viewContractExplorer: 'View contract on explorer',
  viewPairExplorer: 'View pair on explorer',
  copyContractAddress: 'Copy contract address',
  copyWethAddress: 'Copy WETH contract address',
  copyTokenContract: (symbol: string) => `Copy ${symbol} contract`,
  copyPairContract: 'Copy pair contract',
  pairContract: 'Pair contract',
  tokenProfileSheet: (symbol: string) => `${symbol} profile`,
  noPublicLinks: 'No public links registered for this token.',
  inCirculationSince: (date: string) => `In circulation since ${date}`,
  marketCap: 'Market cap',
  volume24h: '24h volume',
  supply: 'Supply',
  holders: 'Holders',
  overview: 'Overview',
  liquidity: 'Liquidity',
  reservesAndContracts: 'Reserves and contracts',
  share: 'Share',
  myPositions: 'My positions',
  positions: 'Positions',
  tvlFee: (tvl: string, fee: string) => `TVL ${tvl} · Fee ${fee}`,
  volPrefix: (value: string) => `Vol ${value}`,
  chartTimeframe: 'Chart timeframe',
  hideChart: 'Hide chart',
  showChart: 'Show chart',
  numericKeypad: 'Numeric keypad',
  invertSwapDirection: 'Invert swap direction',
  invertSwapDirectionAndQuote: 'Invert swap direction and quote',
  invertMarketQuoteRef: 'Invert market quote reference',
  invertMarketRef: 'Invert market reference',
  pairNotInMarketIndex: 'Pair not available in the market index.',
  transactionRejectedPreview: 'Transaction rejected (preview)',
} as const
